import {useContext, useEffect, useState} from 'react';
import AccountStore from 'src/stores/AccountStore';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import NavActions from 'src/actions/NavActions';
import AppRoutes from 'src/AppRoutes';
import {getDescriber as getDescriberCommon} from './descriptors/campusComponents/DescriptorType';
import {getDescriber} from './descriptors/rewardsLegacyViewDescriptor/DescriptorType';
import MainConsumerContext from 'src/components/MainConsumerContext';
import Localized from 'src/constants/AppStrings';
import withIsConnected from 'src/components/hoc/withIsConnected';
import {IsConnectedProps} from 'src/types/Screen';

const styles = getDescriber().getStyleDescriptor();

type RewardsViewProps = IsConnectedProps;
const RewardsLegacyView = (props: RewardsViewProps) => {
  const [isRewardsEnabled, setIsRewardsEnabled] = useState(false);
  const [isOfferAvailable, setIsOfferAvailable] = useState(false);
  const context = useContext(MainConsumerContext);
  useEffect(() => {
    checkRewardsStatus();
    FirebaseAnalytic.trackEvent('componentDidMount', 'RewardsView');
    AccountStore.addChangeListener(checkRewardsStatus);

    const response = AccountStore.getThresholdsResponse();

    if (response?.status === 'ok') {
      const data = response?.data?.filter(
        (reward) => reward?.points <= context?.state?.rewards,
      );
      setIsOfferAvailable(data?.length > 0 ? true : false);
    }
    return () => {
      AccountStore.removeChangeListener(checkRewardsStatus);
    };
  }, []);

  //checkRewardsStatus based on User and Home location settings
  const checkRewardsStatus = () => {
    if (context?.state?.rewards > 0) {
      setIsRewardsEnabled(true);
    } else {
      setIsRewardsEnabled(false);
    }
  };

  //Send a snack action
  const onRewardsClick = () => {
    FirebaseAnalytic.trackEvent('onRewardsClick', 'RewardsView');
    NavActions.navigate(AppRoutes.RewardsScreen);
  };
  const describerprops = {
    styles,
    stat:
      context?.state?.rewards &&
      Localized.Labels.formatString(
        Localized.Labels.balance_points,
        context?.state?.rewards,
      ),
    onRewardsClick,
    isOfferAvailable,
  };

  return isRewardsEnabled && props.isConnected
    ? getDescriberCommon().rewardsLegacyViewDescriptor(describerprops)
    : null;
};

export default withIsConnected(RewardsLegacyView);
